import { gspx } from '@rsos/gainsight';

export const trackAcceptAlertFromToast = ({ alertID, irpVersion, isTest }) => {
  const buttonLabel = isTest ? 'ACCEPT TEST' : 'ACCEPT';

  gspx.trackCustomEvent('Alert', {
    irpVersion,
    name: `Click alert toast ${buttonLabel} button in RSP`,
    Category: 'Alert',
    'Launched date': new Date(),
    AlertID: alertID,
  });
};
